import { _ep0, _mw0, command } from "../commandBuilder";
import { SummarizeUsers$ } from "../schemas/schemas_0";
export class SummarizeUsersCommand extends command(_ep0, _mw0, "SummarizeUsers", SummarizeUsers$) {
}
